"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnPtUsd = exports.EnPtEur = exports.PtPtUsd = exports.PtPtEur = void 0;
class PtPtEur {
    constructor() {
        this.locale = "pt-pt";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d de MMMM de yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: " ",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.PtPtEur = PtPtEur;
class PtPtUsd {
    constructor() {
        this.locale = "pt-pt";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d de MMMM de yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.PtPtUsd = PtPtUsd;
class EnPtEur {
    constructor() {
        this.locale = "en-pt";
        this.dateFormat = {
            short: "dd-MM-yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "€",
            decimalSeparator: ",",
            groupSeparator: ".",
            positivePattern: "n C",
            negativePattern: "-n C"
        };
    }
}
exports.EnPtEur = EnPtEur;
class EnPtUsd {
    constructor() {
        this.locale = "en-pt";
        this.dateFormat = {
            short: "dd-MM-yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "C -n"
        };
    }
}
exports.EnPtUsd = EnPtUsd;
